import React, { useEffect, useState } from "react";
import LockerDetailsComponent from "../components/LockerDetailsComponent";
import DateTimeSelector from "../components/DateTimeSelector";
import { useHistory } from "react-router-dom";
import { AdvanceBookingLockerBankDetails } from "../api/api";
import BookingSummary from "../components/BookingSummary";
import ButtonComponent from "../components/ButtonComponent";
import LockerDurationDialog from "../components/LockerDurationDialog";
import { storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { ADVANCE_BOOKING, LOCAL_STORAGE, LS_BOOKING_TYPE } from "../assets/constants/BrowserStorageKeys";

export default function LockerDetailsPage() {
  const history = useHistory();
  const { lockerDetails } = history.location?.state || {};
  const [showDateTimeSelector, setShowDateTimeSelector] = useState(false);

  console.log("lockerDetails: ", lockerDetails);

  const handleBookStore = () => {
    console.log("Booking store:", lockerDetails);
    setShowDateTimeSelector(true);

    // Scroll to DateTimeSelector smoothly
    setTimeout(() => {
      document
        .querySelector(".locker-details-page__datetime-section")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 100);
  };

  const handleBackToDetails = () => {
    setShowDateTimeSelector(false);

    // Scroll back to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDateTimeContinue = async(dateTimeData) => {
    console.log("DateTime selected:", dateTimeData);

    // Combine locker details + datetime
    const bookingData = {
        locker: lockerDetails,
        ...dateTimeData,
    };
    console.log("Complete booking data:", bookingData);
  const requestData = {
    lockerBankId: lockerDetails?.id,
    reserve_start: bookingData?.reserve_start,
    reserve_end: bookingData?.reserve_end
  };

  console.log("Request Data:", requestData);
    
    const response = await AdvanceBookingLockerBankDetails(requestData);
    const advacnelockerResponse = response?.data?.data;

    console.log("advacnelockerResponse:", advacnelockerResponse);

    const tempdata = {
        lockerBankId: advacnelockerResponse?.id,
        bookingTimingObject: {
          ...dateTimeData
        },
        assignmentSlug: advacnelockerResponse?.locker_assignments[0]?.slug,
        locker_bank_slug:advacnelockerResponse?.slug,
        userId: null,
        availableLockerSizes: advacnelockerResponse?.door_sizes || [],
        isManualLockerSelectionEnabled: advacnelockerResponse?.isManualLockerSelectionEnabled,
        IsAdvanceBooking: true,
        address: advacnelockerResponse?.address_line1 ? advacnelockerResponse?.address_line1 : advacnelockerResponse?.address_line2 
    };
    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_BOOKING_TYPE, ADVANCE_BOOKING )
    console.log("tempdata:", tempdata);

    history.push({
        pathname: "/locker-size",
        state: { ...tempdata }
    });

    
  };

  if (!lockerDetails) {
    return (
      <div className="locker-details-page">
        <div className="locker-details-page__error">
          <h2>No locker details found</h2>
          <p>Please go back and select a locker.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="locker-details-page">
        {/* Conditional Rendering */}
        {!showDateTimeSelector ? (
          <div className="locker-details-container">
            <LockerDetailsComponent
              locker={lockerDetails}
              onBook={handleBookStore}
            />
          </div>
        ) : (
          <div className="locker-datetime-picker-container">
            <DateTimeSelector onContinue={handleDateTimeContinue} />
          </div>
        )}
       
       
      </div>
  );
}